import {
  StorageObject,
  NormalizedStorageObject,
} from "../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export function normalizeLeafStorageObject<T extends StorageObjectValue>(
  object: StorageObject<T>,
): NormalizedStorageObject<T> {
  const { children, ...rest } = object;

  return {
    ...rest,
    parentId: null,
    childrenIds: children?.map((c) => c.id) || [],
  };
}
